// helpers
import DTM from 'shared/helpers/DTM';

export const onProductClick = (item: Listing.IProduct) => {
  DTM.track('product-card-click', {
    product_id: item.id,
    parentSku: item.sku,
    price: item.price,
    salePrice: item.discountedPrice ? item.discountedPrice : item.price,
    productName: item.subTitle,
    productBrand: item.title,
    productPosition: item.lcp ? item.lcp + 1 : undefined,
  });
};
